import useHook from './hooks'
import TableAntd from '../../components/TableAntd'
import { MailFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  Row,
  Space,
  Tabs,
  Tooltip,
} from 'antd'
import { ReactComponent as SoundIcon } from '../../assets/img/svg/sound.svg'
import { ReactComponent as SoundGreenIcon } from '../../assets/img/svg/sound-green.svg'
import FinancialTicketModal from './components/financialTicketModal'
import { formatTime } from '../../tools/util'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { fileFile } from '../../modules/uploadfiles/hooks'
import DownloadIcon from '../../assets/img/download.png'
import PreviewModal from '../../components/previewModal'
import { CustomerInfo } from '../../components/ModalUser'
import Customupload from '../../components/UploadFile'
import FinancialTicketBatchModal from './components/financialTicketBatchModal'

export const FINANCIAL_INVOICE_FILE_TYPE = '.pdf,.jpg,.png,.jpeg'

export default function FinancialReconciliationDetail() {
  const {
    state,
    isAddModalVisible,
    invoiceForm,
    handleDelTicket,
    handleAddOrderModalCancel,
    handleSumitSuccess,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
    handleSaveTicket,
    handleEditTicket,
    enterModify,
    exrpotInvoiceWidthOrder,
    beforeUpload,
    onBatchModalSubmit,
    changeBatchModalVisible,
    onCopy,
  } = useHook()
  const {
    detailInfo,
    isTableLoading,
    ticketInfoList,
    editIndex,
    isSaveButtonLoading,
    isPreviewModalVisible,
    previewFileUrl,
    invoiceBatchModalVisible,
    finanicialInvoiceType,
    batchUploadLoading,
  } = state
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const formConfig: {
    [x: string]: {
      listColumn: any[]
      data?: any[]
    }
  } = {
    订单明细: {
      listColumn: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
          width: 100,
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
          width: 100,
        },
        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          width: 100,
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
          width: 100,
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
          width: 100,
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          width: 100,
        },
        {
          key: 'orderInvoiceStatus',
          dataIndex: 'orderInvoiceStatus',
          title: '客户开票',
          width: 100,
        },
        {
          key: 'customerPayback',
          dataIndex: 'customerPayback',
          title: '客户回款',
          width: 100,
        },
      ],
      data: detailInfo?.orderInfoList,
    },
    物料明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '商品编码',
          width: 100,
        },
        {
          key: 'brandName',
          dataIndex: 'brandName',
          title: '品牌',
          width: 100,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 100,
        },
        {
          key: 'productCount',
          dataIndex: 'productCount',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 100,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
        },
      ],
      data: detailInfo?.productInfoList,
    },
  }

  const ticketIinfoColumn = [
    {
      key: 'invoiceNum',
      dataIndex: 'invoiceNum',
      title: '发票号',
      width: 150,
    },
    {
      key: 'invoiceCode',
      dataIndex: 'invoiceCode',
      title: '发票代码',
      width: 150,
    },
    {
      key: 'invoiceTime',
      dataIndex: 'invoiceTime',
      title: '开票日期',
      width: 150,
      render: (text: string) => {
        return formatTime(text + '')
      },
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '含税金额',
      width: 150,
    },
    {
      key: 'logisticsCompany',
      dataIndex: 'logisticsCompany',
      title: '物流公司',
      width: 150,
    },
    {
      key: 'logisticsNum',
      dataIndex: 'logisticsNum',
      title: '物流单号',
      width: 150,
    },
    {
      key: 'fileList',
      dataIndex: 'fileList',
      title: '发票附件',
      render: (text: fileFile[]) => (
        <Space
          align="center"
          size={4}
          style={{
            width: '100%',
            flexWrap: 'wrap',
          }}
        >
          {text.map((item, index) => (
            <span key={index}>
              {index > 0 ? <span style={{ marginRight: '4px' }}>,</span> : null}
              <span
                className="primaryBtn"
                onClick={() => showPreviewModal(item.baseUrl + item.url)}
              >
                附件{index + 1}
              </span>
            </span>
          ))}
          {text.length > 0 ? (
            <Tooltip title="下载发票" getPopupContainer={() => document.body}>
              <img
                src={DownloadIcon}
                alt=""
                style={{
                  margin: '8px 0',
                  cursor: 'pointer',
                  width: '20px',
                  maxWidth: '20px',
                }}
                onClick={() => onPackageDownload(text)}
              />
            </Tooltip>
          ) : null}
        </Space>
      ),
    },
    ...(detailInfo?.accountOpenInvoiceStatus !== '已开票'
      ? [
          {
            key: 'logisticsNum',
            dataIndex: 'logisticsNum',
            title: '操作',
            width: 100,
            render: (text: any, record: any, index: number) => {
              return (
                <Space>
                  <span
                    className="btn-link"
                    onClick={() => handleEditTicket(index)}
                  >
                    编辑
                  </span>
                  <span
                    className="btn-danger"
                    onClick={() => handleDelTicket(index)}
                  >
                    删除
                  </span>
                </Space>
              )
            },
          },
        ]
      : []),
  ]

  // 展示发票抬头
  const onShowInvoiceTitle = () => {
    CustomerInfo({
      icon: '',
      content: (
        <p style={{ whiteSpace: 'pre-line' }}>
          {`企业名称：万聚国际（杭州）供应链有限公司
          企业地址：浙江省杭州市拱墅区兴业街27-2号602室
          电话TEL： 0571-85874198
          纳税识别号：91330100 5687 500827
          开户行：杭州银行石桥支行
          账号：3301040160000887342
          收票地址请咨询工作人员`}
        </p>
      ),
    })
  }

  const items: MenuProps['items'] = [
    {
      key: 'manual',
      label: (
        <Button
          type="link"
          onClick={() => {
            changeBatchModalVisible(true, 'manual')
          }}
        >
          手动填写
        </Button>
      ),
    },
    {
      key: 'batchUpload',
      label: (
        <Customupload
          accept={FINANCIAL_INVOICE_FILE_TYPE}
          uploadBtn={
            <Button type="link" size="small" style={{ margin: '0 0 10px 0' }}>
              批量导入发票
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple
        />
      ),
    },
  ]

  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <div className={styles['header-left']}>
            <span style={{ marginRight: 8 }}>单据信息</span>
            {detailInfo?.accountStatus === '对账中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                  }}
                />
                <span className={styles['orange-tip']}>
                  等待后台管理员确认对账单
                </span>
              </Space>
            ) : detailInfo?.accountStatus === '对账完成' ? (
              <Space size={'small'} align="center">
                <SoundGreenIcon
                  style={{
                    width: '14px',
                    height: '14px',
                  }}
                />
                <span className={styles['green-tip']}>
                  对账完成，可上传发票
                </span>
              </Space>
            ) : detailInfo?.accountStatus === '驳回待修改' ? (
              <span
                className={styles['red-tip']}
                title={detailInfo.groundsForRejection}
              >
                驳回，待修改！驳回理由：{detailInfo.groundsForRejection}
              </span>
            ) : null}
          </div>
          {detailInfo?.accountStatus === '驳回待修改' && (
            <Button type="primary" onClick={enterModify} size="middle">
              修改对账单
            </Button>
          )}
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <span>对账单号：</span>
              <span>{detailInfo?.accountNo}</span>
            </Col>
            <Col span={8}>
              <span>提交时间：</span>
              <span>{detailInfo?.commitTime}</span>
            </Col>
            <Col span={8}>
              <span>提交人：</span>
              <span>{detailInfo?.createSupplier}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>对账状态：</span>
              <span>{detailInfo?.accountStatus}</span>
            </Col>
            <Col span={8}>
              <span>审核时间：</span>
              <span>{detailInfo?.confirmTime}</span>
            </Col>
            <Col span={8}>
              <span>审核人：</span>
              <span>{detailInfo?.confirmMan}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开票状态：</span>
              <span>{detailInfo?.accountOpenInvoiceStatus}</span>
            </Col>
            <Col span={8}>
              <span>对账金额：</span>
              <span>{detailInfo?.accountPrice}</span>
            </Col>
            <Col
              span={8}
              style={{
                wordBreak: 'break-all',
              }}
            >
              <span>供应商备注： </span>
              <span> {detailInfo?.supplierRemark}</span>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Tabs
          style={{
            width: '100%',
          }}
        >
          {Object.keys(formConfig).map((item) => {
            return (
              <Tabs.TabPane tab={item} key={item}>
                <TableAntd
                  dataSource={formConfig[item].data ?? []}
                  loading={isTableLoading}
                  listColumn={formConfig[item].listColumn}
                  rowKey={item === '物料明细' ? 'productId' : 'orderId'}
                  scrollCustom={{ y: 400 }}
                  scrollStyle={{
                    height: 'auto',
                  }}
                ></TableAntd>
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </div>
      <div className={styles['ticket-email-add']}>
        <ExclamationCircleOutlined
          style={{ margin: '0 8px', color: '#faad15' }}
        />
        <span>电票收票邮箱：czk0529@xianhengguoji.com</span>
        <span className={styles['copy-email']} onClick={() => onCopy('email')}>
          复制
        </span>
        <span>
          线下寄票地址：王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室
        </span>
        <span
          className={styles['copy-address']}
          onClick={() => onCopy('address')}
        >
          复制
        </span>
      </div>
      <div className={styles['ticket-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>发票信息</span>
            </Space>

            <Space size={16}>
              {detailInfo?.accountOpenInvoiceStatus === '已开票' ? (
                <span className={styles['green-tip']}>
                  审核通过，进项票生效
                </span>
              ) : detailInfo?.accountStatus === '对账完成' ? (
                <>
                  {detailInfo?.accountOpenInvoiceStatus === '审核中' ? (
                    <span className={styles['orange-tip']}>
                      咸亨审核中，请耐心等待
                    </span>
                  ) : (
                    <span className={styles['orange-tip']}>
                      <MailFilled style={{ marginRight: 10 }} />
                      请按照右侧的发票抬头开票，并将寄票随单和纸质票一起寄出
                    </span>
                  )}

                  <Button size="middle" onClick={onShowInvoiceTitle}>
                    发票抬头
                  </Button>

                  {detailInfo?.accountOpenInvoiceStatus === '未开票' && (
                    <Button size="middle" onClick={exrpotInvoiceWidthOrder}>
                      导出寄票随单
                    </Button>
                  )}
                  <Dropdown
                    menu={{ items }}
                    placement="bottom"
                    trigger={['click']}
                  >
                    <Button size="middle">上传发票</Button>
                  </Dropdown>

                  <Button
                    type="primary"
                    size="middle"
                    onClick={handleSaveTicket}
                    loading={isSaveButtonLoading}
                  >
                    保存并提交审核
                  </Button>
                </>
              ) : null}
            </Space>
          </Row>
        </div>
        <div className={styles['content']}>
          {['', '不可对账', '可对帐', '对账中'].includes(
            detailInfo?.accountStatus || '',
          ) &&
          detailInfo?.accountOpenInvoiceStatus === '未开票' &&
          ticketInfoList.length < 1 ? (
            <div className={styles['ticket-inner']}>
              <span>对账完成后上传</span>
            </div>
          ) : null}

          {detailInfo?.accountStatus === '对账完成' &&
          detailInfo?.accountOpenInvoiceStatus === '未开票' &&
          ticketInfoList.length < 1 ? (
            <div className={styles['ticket-inner']}>
              <span>对账完成，请上传发票</span>
            </div>
          ) : null}
          {ticketInfoList.length > 0 ? (
            <TableAntd
              dataSource={ticketInfoList ?? []}
              loading={isTableLoading}
              listColumn={ticketIinfoColumn}
              rowKey={'accountInvoiceId'}
              scrollCustom={{ y: 400 }}
              scrollStyle={{
                height: 'auto',
              }}
            ></TableAntd>
          ) : null}
        </div>
      </div>
      <FinancialTicketModal
        open={isAddModalVisible}
        detailInfo={detailInfo}
        handleSumitSuccess={handleSumitSuccess}
        modalCancel={handleAddOrderModalCancel}
        editIndex={editIndex}
        ticketList={ticketInfoList}
      />
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
      <FinancialTicketBatchModal
        form={invoiceForm}
        open={invoiceBatchModalVisible}
        detailInfo={detailInfo}
        modalCancel={() => changeBatchModalVisible(false)}
        modalSubmit={onBatchModalSubmit}
        type={finanicialInvoiceType}
        loading={batchUploadLoading}
      />
    </div>
  )
}
import useHook from './hooks'
import TableAntd from '../../components/TableAntd'
import { MailFilled, ExclamationCircleOutlined } from '@ant-design/icons'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  Row,
  Space,
  Tabs,
  Tooltip,
} from 'antd'
import { ReactComponent as SoundIcon } from '../../assets/img/svg/sound.svg'
import { ReactComponent as SoundGreenIcon } from '../../assets/img/svg/sound-green.svg'
import FinancialTicketModal from './components/financialTicketModal'
import { formatTime } from '../../tools/util'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import { fileFile } from '../../modules/uploadfiles/hooks'
import DownloadIcon from '../../assets/img/download.png'
import PreviewModal from '../../components/previewModal'
import { CustomerInfo } from '../../components/ModalUser'
import Customupload from '../../components/UploadFile'
import FinancialTicketBatchModal from './components/financialTicketBatchModal'

export const FINANCIAL_INVOICE_FILE_TYPE = '.pdf,.jpg,.png,.jpeg'

export default function FinancialReconciliationDetail() {
  const {
    state,
    isAddModalVisible,
    invoiceForm,
    handleDelTicket,
    handleAddOrderModalCancel,
    handleSumitSuccess,
    onPackageDownload,
    showPreviewModal,
    cancelPreviewModal,
    handleSaveTicket,
    handleEditTicket,
    enterModify,
    exrpotInvoiceWidthOrder,
    beforeUpload,
    onBatchModalSubmit,
    changeBatchModalVisible,
    onCopy,
  } = useHook()
  const {
    detailInfo,
    isTableLoading,
    ticketInfoList,
    editIndex,
    isSaveButtonLoading,
    isPreviewModalVisible,
    previewFileUrl,
    invoiceBatchModalVisible,
    finanicialInvoiceType,
    batchUploadLoading,
  } = state
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const formConfig: {
    [x: string]: {
      listColumn: any[]
      data?: any[]
    }
  } = {
    订单明细: {
      listColumn: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
          width: 100,
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
          width: 100,
        },
        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          width: 100,
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
          width: 100,
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
          width: 100,
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          width: 100,
        },
        {
          key: 'orderInvoiceStatus',
          dataIndex: 'orderInvoiceStatus',
          title: '客户开票',
          width: 100,
        },
        {
          key: 'customerPayback',
          dataIndex: 'customerPayback',
          title: '客户回款',
          width: 100,
        },
      ],
      data: detailInfo?.orderInfoList,
    },
    物料明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '商品编码',
          width: 100,
        },
        {
          key: 'brandName',
          dataIndex: 'brandName',
          title: '品牌',
          width: 100,
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 100,
        },
        {
          key: 'productCount',
          dataIndex: 'productCount',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 100,
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
          width: 100,
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          width: 100,
        },
      ],
      data: detailInfo?.productInfoList,
    },
  }

  const ticketIinfoColumn = [
    {
      key: 'invoiceNum',
      dataIndex: 'invoiceNum',
      title: '发票号',
      width: 150,
    },
    {
      key: 'invoiceCode',
      dataIndex: 'invoiceCode',
      title: '发票代码',
      width: 150,
    },
    {
      key: 'invoiceTime',
      dataIndex: 'invoiceTime',
      title: '开票日期',
      width: 150,
      render: (text: string) => {
        return formatTime(text + '')
      },
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '含税金额',
      width: 150,
    },
    {
      key: 'logisticsCompany',
      dataIndex: 'logisticsCompany',
      title: '物流公司',
      width: 150,
    },
    {
      key: 'logisticsNum',
      dataIndex: 'logisticsNum',
      title: '物流单号',
      width: 150,
    },
    {
      key: 'fileList',
      dataIndex: 'fileList',
      title: '发票附件',
      render: (text: fileFile[]) => (
        <Space
          align="center"
          size={4}
          style={{
            width: '100%',
            flexWrap: 'wrap',
          }}
        >
          {text.map((item, index) => (
            <span key={index}>
              {index > 0 ? <span style={{ marginRight: '4px' }}>,</span> : null}
              <span
                className="primaryBtn"
                onClick={() => showPreviewModal(item.baseUrl + item.url)}
              >
                附件{index + 1}
              </span>
            </span>
          ))}
          {text.length > 0 ? (
            <Tooltip title="下载发票" getPopupContainer={() => document.body}>
              <img
                src={DownloadIcon}
                alt=""
                style={{
                  margin: '8px 0',
                  cursor: 'pointer',
                  width: '20px',
                  maxWidth: '20px',
                }}
                onClick={() => onPackageDownload(text)}
              />
            </Tooltip>
          ) : null}
        </Space>
      ),
    },
    ...(detailInfo?.accountOpenInvoiceStatus !== '已开票'
      ? [
          {
            key: 'logisticsNum',
            dataIndex: 'logisticsNum',
            title: '操作',
            width: 100,
            render: (text: any, record: any, index: number) => {
              return (
                <Space>
                  <span
                    className="btn-link"
                    onClick={() => handleEditTicket(index)}
                  >
                    编辑
                  </span>
                  <span
                    className="btn-danger"
                    onClick={() => handleDelTicket(index)}
                  >
                    删除
                  </span>
                </Space>
              )
            },
          },
        ]
      : []),
  ]

  // 展示发票抬头
  const onShowInvoiceTitle = () => {
    CustomerInfo({
      icon: '',
      content: (
        <p style={{ whiteSpace: 'pre-line' }}>
          {`企业名称：万聚国际（杭州）供应链有限公司
          企业地址：浙江省杭州市拱墅区兴业街27-2号602室
          电话TEL： 0571-85874198
          纳税识别号：91330100 5687 500827
          开户行：杭州银行石桥支行
          账号：3301040160000887342
          收票地址请咨询工作人员`}
        </p>
      ),
    })
  }

  const items: MenuProps['items'] = [
    {
      key: 'manual',
      label: (
        <Button
          type="link"
          onClick={() => {
            changeBatchModalVisible(true, 'manual')
          }}
        >
          手动填写
        </Button>
      ),
    },
    {
      key: 'batchUpload',
      label: (
        <Customupload
          accept={FINANCIAL_INVOICE_FILE_TYPE}
          uploadBtn={
            <Button type="link" size="small" style={{ margin: '0 0 10px 0' }}>
              批量导入发票
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple
        />
      ),
    },
  ]

  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <div className={styles['header-left']}>
            <span style={{ marginRight: 8 }}>单据信息</span>
            {detailInfo?.accountStatus === '对账中' ? (
              <Space size={'small'} align="center">
                <SoundIcon
                  style={{
                    width: '14px',
                    height: '14px',
                  }}
                />
                <span className={styles['orange-tip']}>
                  等待后台管理员确认对账单
                </span>
              </Space>
            ) : detailInfo?.accountStatus === '对账完成' ? (
              <Space size={'small'} align="center">
                <SoundGreenIcon
                  style={{
                    width: '14px',
                    height: '14px',
                  }}
                />
                <span className={styles['green-tip']}>
                  对账完成，可上传发票
                </span>
              </Space>
            ) : detailInfo?.accountStatus === '驳回待修改' ? (
              <span
                className={styles['red-tip']}
                title={detailInfo.groundsForRejection}
              >
                驳回，待修改！驳回理由：{detailInfo.groundsForRejection}
              </span>
            ) : null}
          </div>
          {detailInfo?.accountStatus === '驳回待修改' && (
            <Button type="primary" onClick={enterModify} size="middle">
              修改对账单
            </Button>
          )}
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <span>对账单号：</span>
              <span>{detailInfo?.accountNo}</span>
            </Col>
            <Col span={8}>
              <span>提交时间：</span>
              <span>{detailInfo?.commitTime}</span>
            </Col>
            <Col span={8}>
              <span>提交人：</span>
              <span>{detailInfo?.createSupplier}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>对账状态：</span>
              <span>{detailInfo?.accountStatus}</span>
            </Col>
            <Col span={8}>
              <span>审核时间：</span>
              <span>{detailInfo?.confirmTime}</span>
            </Col>
            <Col span={8}>
              <span>审核人：</span>
              <span>{detailInfo?.confirmMan}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开票状态：</span>
              <span>{detailInfo?.accountOpenInvoiceStatus}</span>
            </Col>
            <Col span={8}>
              <span>对账金额：</span>
              <span>{detailInfo?.accountPrice}</span>
            </Col>
            <Col
              span={8}
              style={{
                wordBreak: 'break-all',
              }}
            >
              <span>供应商备注： </span>
              <span> {detailInfo?.supplierRemark}</span>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Tabs
          style={{
            width: '100%',
          }}
        >
          {Object.keys(formConfig).map((item) => {
            return (
              <Tabs.TabPane tab={item} key={item}>
                <TableAntd
                  dataSource={formConfig[item].data ?? []}
                  loading={isTableLoading}
                  listColumn={formConfig[item].listColumn}
                  rowKey={item === '物料明细' ? 'productId' : 'orderId'}
                  scrollCustom={{ y: 400 }}
                  scrollStyle={{
                    height: 'auto',
                  }}
                ></TableAntd>
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </div>
      <div className={styles['ticket-email-add']}>
        <ExclamationCircleOutlined
          style={{ margin: '0 8px', color: '#faad15' }}
        />
        <span>电票收票邮箱：czk0529@xianhengguoji.com</span>
        <span className={styles['copy-email']} onClick={() => onCopy('email')}>
          复制
        </span>
        <span>
          线下寄票地址：王亚，17855973107，浙江省嘉兴市海宁市启辉路16号1号楼6楼财务室
        </span>
        <span
          className={styles['copy-address']}
          onClick={() => onCopy('address')}
        >
          复制
        </span>
      </div>
      <div className={styles['ticket-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>发票信息</span>
            </Space>

            <Space size={16}>
              {detailInfo?.accountOpenInvoiceStatus === '已开票' ? (
                <span className={styles['green-tip']}>
                  审核通过，进项票生效
                </span>
              ) : detailInfo?.accountStatus === '对账完成' ? (
                <>
                  {detailInfo?.accountOpenInvoiceStatus === '审核中' ? (
                    <span className={styles['orange-tip']}>
                      咸亨审核中，请耐心等待
                    </span>
                  ) : (
                    <span className={styles['orange-tip']}>
                      <MailFilled style={{ marginRight: 10 }} />
                      请按照右侧的发票抬头开票，并将寄票随单和纸质票一起寄出
                    </span>
                  )}

                  <Button size="middle" onClick={onShowInvoiceTitle}>
                    发票抬头
                  </Button>

                  {detailInfo?.accountOpenInvoiceStatus === '未开票' && (
                    <Button size="middle" onClick={exrpotInvoiceWidthOrder}>
                      导出寄票随单
                    </Button>
                  )}
                  <Dropdown
                    menu={{ items }}
                    placement="bottom"
                    trigger={['click']}
                  >
                    <Button size="middle">上传发票</Button>
                  </Dropdown>

                  <Button
                    type="primary"
                    size="middle"
                    onClick={handleSaveTicket}
                    loading={isSaveButtonLoading}
                  >
                    保存并提交审核
                  </Button>
                </>
              ) : null}
            </Space>
          </Row>
        </div>
        <div className={styles['content']}>
          {['', '不可对账', '可对帐', '对账中'].includes(
            detailInfo?.accountStatus || '',
          ) &&
          detailInfo?.accountOpenInvoiceStatus === '未开票' &&
          ticketInfoList.length < 1 ? (
            <div className={styles['ticket-inner']}>
              <span>对账完成后上传</span>
            </div>
          ) : null}

          {detailInfo?.accountStatus === '对账完成' &&
          detailInfo?.accountOpenInvoiceStatus === '未开票' &&
          ticketInfoList.length < 1 ? (
            <div className={styles['ticket-inner']}>
              <span>对账完成，请上传发票</span>
            </div>
          ) : null}
          {ticketInfoList.length > 0 ? (
            <TableAntd
              dataSource={ticketInfoList ?? []}
              loading={isTableLoading}
              listColumn={ticketIinfoColumn}
              rowKey={'accountInvoiceId'}
              scrollCustom={{ y: 400 }}
              scrollStyle={{
                height: 'auto',
              }}
            ></TableAntd>
          ) : null}
        </div>
      </div>
      <FinancialTicketModal
        open={isAddModalVisible}
        detailInfo={detailInfo}
        handleSumitSuccess={handleSumitSuccess}
        modalCancel={handleAddOrderModalCancel}
        editIndex={editIndex}
        ticketList={ticketInfoList}
      />
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      />
      <FinancialTicketBatchModal
        form={invoiceForm}
        open={invoiceBatchModalVisible}
        detailInfo={detailInfo}
        modalCancel={() => changeBatchModalVisible(false)}
        modalSubmit={onBatchModalSubmit}
        type={finanicialInvoiceType}
        loading={batchUploadLoading}
      />
    </div>
  )
}
